<template>
	<header class="main-header">
		<div class="header-inner">
			<div class="logo-holder">
				<router-link to="/">
					<picture class="logo">
						<source srcset="/images/front/logo-light.svg" media="(prefers-color-scheme: dark)">
						<img src="/images/front/logo-dark.svg" />
					</picture>
				</router-link>
			</div>
			<div class="menu-holder">
				<div class="top-menu" v-if="width >= 900">
					<account-menu @open="open = false"></account-menu>
				</div>
				<div class="bottom-menu" v-if="width >= 900">
					<main-menu class="menu" @open="open = false"></main-menu>
				</div>
			</div>
		</div>
		<button class="mobile-toggle" v-if="width < 900" @click.prevent="open = true"><icon icon="essentials/basics/menu-circle"></icon></button>
		<transition name="fade">
			<div class="mobile-menu" v-if="open && width < 900">
				<button class="mobile-toggle" @click.prevent="open = false"><icon icon="essentials/basics/close-circle"></icon></button>
				<div class="menu-holder">
					<main-menu class="mobile-nav" @open="open = false"></main-menu>
					<account-menu @open="open = false"></account-menu>
				</div>
			</div>
		</transition>
	</header>
</template>

<script>
	export default {
		data() {
			return {
				open: false,
				
			};
		},
		computed: {
			width() {
				return this.$store.state.screenWidth;
			}
		},
		watch: {
			'$route.query.q': function() {
				this.search = this.$route.query.q || '';
			}
		},
		methods: {
			async goToSearch() {
				this.errors = {};
				if(!this.search) {
					this.errors.search = ['Search term is required'];
					return;
				}
				await this.$navigate('/search?q=' + this.search);
			}
		}
	}
</script>